var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.067,
    height: 22.934,
    viewBox: "0 0 20.067 22.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar",
    "data-name": "Icon awesome-calendar",
    d: "M.538,8.6H19.529a.539.539,0,0,1,.538.538V20.783a2.151,2.151,0,0,1-2.15,2.15H2.15A2.151,2.151,0,0,1,0,20.783V9.138A.539.539,0,0,1,.538,8.6ZM20.067,6.629V5.017a2.151,2.151,0,0,0-2.15-2.15h-2.15V.538A.539.539,0,0,0,15.229,0H13.438A.539.539,0,0,0,12.9.538V2.867H7.167V.538A.539.539,0,0,0,6.629,0H4.838A.539.539,0,0,0,4.3.538V2.867H2.15A2.151,2.151,0,0,0,0,5.017V6.629a.539.539,0,0,0,.538.538H19.529A.539.539,0,0,0,20.067,6.629Z",
    fill: "#ec6321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateicon);
export default __webpack_public_path__ + "static/media/date icon.6e056b4cb597d6341b02d617b05a6a87.svg";
export { ForwardRef as ReactComponent };